import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
export var WM_CAMPAIGN_QUERY = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "WelcomeMessages"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "campaignName"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "assetPath"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "variables"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "JSONObject"
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "campaign"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "params"
          },
          "value": {
            "kind": "ObjectValue",
            "fields": [{
              "kind": "ObjectField",
              "name": {
                "kind": "Name",
                "value": "campaignName"
              },
              "value": {
                "kind": "Variable",
                "name": {
                  "kind": "Name",
                  "value": "campaignName"
                }
              }
            }, {
              "kind": "ObjectField",
              "name": {
                "kind": "Name",
                "value": "assetPath"
              },
              "value": {
                "kind": "Variable",
                "name": {
                  "kind": "Name",
                  "value": "assetPath"
                }
              }
            }, {
              "kind": "ObjectField",
              "name": {
                "kind": "Name",
                "value": "variables"
              },
              "value": {
                "kind": "Variable",
                "name": {
                  "kind": "Name",
                  "value": "variables"
                }
              }
            }]
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "campaign"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "version"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "lastUpdate"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "ctaSection"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "type"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "CTATextColor"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "CTABackgroundColor"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "CTAText"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "CTALinks"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "desktop"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "url"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "target"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "mobile"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "url"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "target"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "nativeIOS"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "url"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "target"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "nativeAndroid"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "url"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "target"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "CTAEvent"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "eventPath"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "ctaLinkStandalone"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "url"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "target"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "selections"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "eventID"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "eventLabel"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "marketID"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "marketLabel"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "selectionID"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "selectionLabel"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "betslipButtonLabel"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "imageSrc"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "high"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "medium"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "low"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "video"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "youtube"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "vimeo"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "termsCondition"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "url"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "label"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "title"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "bodyText"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "selections"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "eventID"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "eventLabel"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "marketID"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "marketLabel"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "selectionID"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "selectionLabel"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "logo"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "dismissable"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "dismissBtnLabel"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "informSDP"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "placeholders"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "source"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "selector"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "default"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 745,
    "source": {
      "body": "query WelcomeMessages($campaignName:String!$assetPath:String!$variables:JSONObject){campaign(params:{campaignName:$campaignName assetPath:$assetPath variables:$variables}){campaign version lastUpdate ctaSection{type CTATextColor CTABackgroundColor CTAText CTALinks{desktop{url target}mobile{url target}nativeIOS{url target}nativeAndroid{url target}}CTAEvent{eventPath ctaLinkStandalone{url target}}selections{eventID eventLabel marketID marketLabel selectionID selectionLabel}betslipButtonLabel}imageSrc{high medium low}video{youtube vimeo}termsCondition{url label}title bodyText selections{eventID eventLabel marketID marketLabel selectionID selectionLabel}logo dismissable dismissBtnLabel informSDP placeholders{name source selector default}}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export var UPDATE_MARKETING_PREFERENCES_MUTATION = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "updateMarketingPreferences"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "marketingPreferencesState"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "MyAccountMarketingPreferencesState"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "updateMarketingPreferences"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "marketingPreferencesState"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "marketingPreferencesState"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "contactable"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "contactables"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "checked"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 222,
    "source": {
      "body": "mutation updateMarketingPreferences($marketingPreferencesState:MyAccountMarketingPreferencesState!){updateMarketingPreferences(marketingPreferencesState:$marketingPreferencesState){id contactable contactables{id checked}}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export var welcomeMessagesQuery = function welcomeMessagesQuery(params) {
  return {
    query: WM_CAMPAIGN_QUERY,
    fetchPolicy: 'no-cache',
    variables: _Object$assign({}, params)
  };
};

// marketingPreferencesState variable is required to be passed
export var marketingPreferencesMutation = function marketingPreferencesMutation(params) {
  return {
    mutation: UPDATE_MARKETING_PREFERENCES_MUTATION,
    fetchPolicy: 'no-cache',
    variables: {
      marketingPreferencesState: _Object$assign({}, params)
    }
  };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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